<template>
    <div class="">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
            <form ref="form" :data-url='selectedUrl ? `companies/${inputs.id}` : `companies`' class="mb-0"
                :class="{ 'loading-opacity': preloader }">
                <div class="form-group row align-items-center">
                    <label class="col-md-2 mb-md-0 required">
                        {{ $t('contact_name') }}
                    </label>
                    <app-input class="col-md-8" type="text" v-model="inputs.name" :required="true"
                        :placeholder="$t('Contact_name')" />
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-2 mb-md-0 required">
                        {{ $t('phone') }}
                    </label>
                    <app-input class="col-md-8" type="tel-input" v-model="inputs.Phone" :required="true" min="6"
                        :placeholder="$t('phone')" />
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-2 mb-md-0">
                        {{ $t('fax') }}
                    </label>
                    <app-input class="col-md-8" type="number" v-model="inputs.Fax"  min="6"
                        :placeholder="$t('fax')" />
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-2 mb-md-0 required">
                        {{ $t('email') }}
                    </label>
                    <app-input class="col-md-8" type="email" v-model="inputs.Email" :required="true" min="6"
                        :placeholder="$t('email')" />
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-2 mb-md-0 required">
                        {{ $t('position') }}
                    </label>
                    <app-input class="col-md-8" type="text" v-model="inputs.Position" :required="true" min="6"
                        :placeholder="$t('position')" />
                </div>

                <div class="mt-5 action-buttons">
                    <button type="button" class="btn btn-primary mr-2" @click="continueBy">{{ $t('continue') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import {validateInputs } from "../../../../../utils"

export default {
    name: "AddProductModal",
    mixins: [FormMixin, ModalMixin],

    data() {
        return {
            preloader: false,
            inputs: {
                name: '',
                Title: '',
                Phone: '',
                Fax: '',
                Email: '',
                Position: '',
            },
        }
    },

    methods: {
        continueBy() {
            const validations = {
                name : { required: true, message: 'the contact name is required.' },
                Phone: { required: true, message: 'Phone number must be between 10 and 15 digits.' },
                Email: { required: true,  message: 'Email cannot exceed 50 characters.' },
                Position: { required: true,  message: 'Position is required' },
            };
            if (!validateInputs(this, this.inputs, validations)) {
                return;
            }
            window.location.href = this.$router.resolve({
                name: 'Addresses-suppliers',
                query: { 'tab': 'Addresses' }
            }).href;
        },        
    },

    watch: {
        // esta en costante escucha de los cambios de los inputs y los va actualizando 
        inputs: {
            deep: true, 
            handler(newVal) {
                localStorage.setItem('ContactSupplier', JSON.stringify(newVal));
            }
        }
    },

    created() {
        const savedInputs = localStorage.getItem('ContactSupplier');
        if (savedInputs) {
            this.inputs = JSON.parse(savedInputs);
        }
    }
}

</script>
